import { Link } from '@remix-run/react'
import { Button } from '#app/components/ui/button'
import { Card } from '#app/components/ui/card'

export default function MaterialityIndex() {
	return (
		<div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
			<Card className="p-6">
				<h2 className="mb-4 text-xl font-semibold">IRO Management</h2>
				<p className="mb-4 text-gray-600">
					Create and manage your Impact, Risk, and Opportunity (IRO) items.
				</p>
				<Link to="iros">
					<Button>Manage IROs</Button>
				</Link>
			</Card>

			<Card className="p-6">
				<h2 className="mb-4 text-xl font-semibold">Topics</h2>
				<p className="mb-4 text-gray-600">
					Organize your IROs into topics and sub-topics.
				</p>
				<Link to="topics">
					<Button>Manage Topics</Button>
				</Link>
			</Card>

			<Card className="p-6">
				<h2 className="mb-4 text-xl font-semibold">Assessments</h2>
				<p className="mb-4 text-gray-600">
					Score your IROs based on Scale, Scope, Remediability, and Likelihood.
				</p>
				<Link to="assessments">
					<Button>View Assessments</Button>
				</Link>
			</Card>

			<Card className="p-6">
				<h2 className="mb-4 text-xl font-semibold">Thresholds</h2>
				<p className="mb-4 text-gray-600">
					Set and manage assessment thresholds for your organization.
				</p>
				<Link to="thresholds">
					<Button>Manage Thresholds</Button>
				</Link>
			</Card>

			<Card className="p-6">
				<h2 className="mb-4 text-xl font-semibold">Dashboard</h2>
				<p className="mb-4 text-gray-600">
					View overall assessment progress and key metrics.
				</p>
				<Link to="dashboard">
					<Button>View Dashboard</Button>
				</Link>
			</Card>

			<Card className="p-6">
				<h2 className="mb-4 text-xl font-semibold">Reports</h2>
				<p className="mb-4 text-gray-600">
					Generate and export assessment reports.
				</p>
				<Link to="reports">
					<Button>View Reports</Button>
				</Link>
			</Card>
		</div>
	)
}
